import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { RecurrenceState } from '../types/recurrence';

export const useRecurrenceStore = create<RecurrenceState>()(
  devtools(
    set => ({
      // Dados da recorrência ativa (carregados da API)
      loaded: false,
      isActive: false,
      frequency: null,
      day: null,
      value: null,
      card: null,
      recipient: null,

      // Dados do formulário de criação (seleções do usuário)
      selectedValue: null,
      selectedCard: null,
      recurrenceValues: [],

      setRecurrenceData: data => set({ ...data }, false, 'setRecurrenceData'),
      setLoaded: loaded => set({ loaded }, false, 'setLoaded'),
      setSelectedValue: selectedValue =>
        set({ selectedValue }, false, 'setSelectedValue'),
      setSelectedCard: selectedCard =>
        set({ selectedCard }, false, 'setSelectedCard'),
      setRecurrenceValues: recurrenceValues =>
        set({ recurrenceValues }, false, 'setRecurrenceValues'),
      clearRecurrence: () =>
        set(
          {
            loaded: false,
            isActive: false,
            frequency: null,
            day: null,
            value: null,
            card: null,
            recipient: null,
            selectedValue: null,
            selectedCard: null,
            recurrenceValues: [],
          },
          false,
          'clearRecurrence',
        ),
    }),
    { name: 'RecurrenceStore' },
  ),
);
